'use client'

import React from "react";
import styles from "./JornadadeAprendizagem.module.css";
import Slider from '@/components/ClientSlider/ClientSlider';
import "slick-carousel/slick/slick.css"; 
import '../../../public/css/slick-custom.css'
import "slick-carousel/slick/slick-theme.css";
import classNames from "classnames";
import jornadaCards from "../../jsons/JornadaAprendizagem.json";
import { usePathname } from "next/navigation";

const JornadadeAprendizagem: React.FC = () => {
  const pathname = usePathname();
  const isSpecificPage = (path: string): boolean => pathname === path;

  const settings = {
    dots: true,
    arrows: false, 
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1240, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  };

  const getTitleAndDescription = () => {
    if (isSpecificPage("/")) {
      return {
        title: "A melhor experiência na jornada de aprendizagem e Lifelong Learning!",
        description: "A Biblioteca Virtual Pearson foi projetada para facilitar a jornada de aprendizagem do usuário na busca por livros, sugestões de leitura com IA e recursos dinâmicos que aprimoram o acesso ao conhecimento e melhoram a experiência da rotina de estudo."
      };
    } else if (isSpecificPage("/NossoAcervo") || isSpecificPage("/QuemSomos")) {
      return {
        title: "A Biblioteca Virtual feita pra você",
        description: ""
      };
    }
    return { title: "", description: "" };
  };

  // Função para truncar textos longos (exemplo: 60 caracteres)
  const truncate = (text: string, maxLength: number) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength).trim() + "...";
  };

  const { title, description } = getTitleAndDescription();

  return (
    <section
      className={classNames(styles.JornadaAprendizagem, {
        [styles.Interna]: ["/NossoAcervo", "/QuemSomos"].some(isSpecificPage)
      })}
      aria-labelledby="jornada-aprendizagem-title"
    >
      <div className="uiContainer">
        {title && (
          <>
            <h2 id="jornada-aprendizagem-title" tabIndex={0} className={styles.titleArea}>
              {title.includes("jornada") ? (
                <>
                  A melhor experiência na <span>jornada de aprendizagem e Lifelong Learning!</span>
                </>
              ) : (
                <>{title}</>
              )}
            </h2>
            {description && (
              <p tabIndex={0} className={styles.descriptionArea}>
                {description}
              </p>
            )}
          </>
        )}

        <div className={styles.carouselContainer}>
          <div className="carrosselProdutos">
            <Slider {...settings}>
              {jornadaCards.filter(card => card.exibir).map((card) => (
                <div key={card.id} className={styles.cardWrapper}>
                  <a
                    href={card.link}
                    aria-labelledby={`ensino-link-${card.id} ensino-link-${card.id}-desc ensino-link-${card.id}-img`}
                    // aria-label={`${card.category} ${card.title} ${card.description}`}
                    // aria-labelledby={`card-ies-self-${card.id} card-ies-category-${card.id} card-ies-title-${card.id} card-ies-desc-${card.id}`}
                    // id={`card-ies-self-${card.id}`}
                  >
                    <article
                      className={classNames(styles.card, styles[`card-${card.color}`])}
                      data-color={card.color}
                    >
                      <img
                        id={`ensino-link-${card.id}-img`}
                        src={card.image}
                        alt={`Imagem do conteúdo ${card.title}`}
                        className={styles.image}
                        loading="lazy"
                        width={308}
                        height={140}
                      />                    

                      {/* <h3 id={`card-ies-title-${card.id}`} className={styles.title}> */}
             
                      <h3 id={`ensino-link-${card.id}`} className={styles.title}>
                        <span
                          className={classNames(styles.category, styles[`color-${card.color}`])}
                        >
                          {card.category}
                        </span>
                        {card.title}
                      </h3>
          

                      {/* <p id={`card-ies-desc-${card.id}`} className={styles.description}> */}
                      <p id={`ensino-link-${card.id}-desc`} className={styles.description}>
                        {card.description}
                      </p>

                      <svg
                        className={classNames(styles.arrow, styles[`arrow-${card.color}`])}
                        width="29"
                        height="28"
                        viewBox="0 0 29 28"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path d="M13.625 0.4375C13.875 0.125 14.375 0.125 14.6875 0.4375L27.75 13.5C28.0625 13.8125 28.0625 14.25 27.75 14.5625L14.6875 27.625C14.375 27.9375 13.875 27.9375 13.625 27.625L12.375 26.4375C12.0625 26.125 12.0625 25.625 12.375 25.375L22.0625 15.625H0.75C0.3125 15.625 0 15.3125 0 14.875V13.125C0 12.75 0.3125 12.375 0.75 12.375H22.0625L12.375 2.6875C12.0625 2.4375 12.0625 1.9375 12.375 1.625L13.625 0.4375Z" />
                      </svg>
                    </article>
                  </a>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JornadadeAprendizagem;